import {Controller, useFormContext} from "react-hook-form";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select,} from "@mui/material";
import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import _ from "lodash";

InputSelect.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    items: PropTypes.array,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    fieldAction: PropTypes.object,
    onChangeOverwrite: PropTypes.func,
};

// @ts-ignore
export default function InputSelect({
                                        name,
                                        label,
                                        items,
                                        disabled,
                                        multiple,
                                        fieldAction,
                                        onChangeOverwrite,
                                    }) {
    const {
        control,
        formState: {isSubmitting},
    } = useFormContext();

    if (fieldAction?.name && !fieldAction?.visible) {
        return <></>
    }


    const [showFieldActionName, setShowFieldActionName] = useState(false);

    useEffect(() => {
        function keyDownHandler(e: globalThis.KeyboardEvent) {
            if (e.ctrlKey && e.key.toLowerCase() === "#"|| e.metaKey && e.key.toLowerCase() === "#") {
                e.preventDefault();
                setShowFieldActionName(prev => !prev);
            }
        }

        document.addEventListener("keydown", keyDownHandler);
        return () => {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, []);


    return (
        <Controller
            name={name}
            control={control}
            render={({field: {onChange, value}, fieldState: {error}}) => {
                const isValidValue = multiple
                    ? Array.isArray(value) && value.every(v => items.some(i => i.id === v))
                    : items.some(i => i.id === value);

                const safeValue = isValidValue ? value : multiple ? [] : "";

                return (
                    <FormControl margin="dense" fullWidth error={!!error}>
                        <InputLabel id={`${name}-label`}>{label}</InputLabel>
                        <Select
                            size="small"
                            labelId={`${name}-label`}
                            data-testid={`${name}-select`}
                            label={showFieldActionName ? fieldAction?.name ?? label : label}
                            fullWidth
                            disabled={isSubmitting || disabled || fieldAction?.disabled}
                            value={safeValue}
                            multiple={multiple}
                            onChange={(event) => {
                                if (_.isFunction(onChangeOverwrite)) {
                                    onChangeOverwrite(event);
                                }
                                onChange(event);
                            }}
                            renderValue={(val: any) => {
                                if (multiple) {
                                    return val
                                        .map((v: any) => items.find(i => i.id === v)?.name)
                                        .filter(Boolean)
                                        .join("; ");
                                }
                                return items.find(i => i.id === val)?.name || "";
                            }}
                        >
                            {items.map((item: any) => (
                                <MenuItem value={item.id} key={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {!!error && (
                            <FormHelperText>{error.message}</FormHelperText>
                        )}
                    </FormControl>
                );
            }}
        />
    );
}
